import React from "react";
import UsersView from "@/modern/components/users/UsersView";

const UserPage = () => {
  return (
    <div
      className="relative flex min-h-0 min-w-0 w-full flex-1 flex-col bg-background"
      id="users-page"
    >
      <div className="min-h-0 flex-1">
        <UsersView />
      </div>
    </div>
  );
};

export default UserPage;
